(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mural-quote-wizard"] && !Shopify.designMode) return;
  try {
    class MuralQuoteWizard extends HTMLElement {
    connectedCallback() {
      this.steps = Array.from(this.querySelectorAll('[data-wizard-step]'));
      if (!this.steps.length) return;

      this.total = this.steps.length;
      this.current = 1;
      this.backButton = this.querySelector('[data-wizard-back]');
      this.nextButton = this.querySelector('[data-wizard-next]');
      this.submitButton = this.querySelector('[data-wizard-submit]');
      this.progressBar = this.querySelector('[data-wizard-progress-bar]');
      this.stepLabel = this.querySelector('[data-wizard-step-label]');

      this.backButton?.addEventListener('click', () => this.goTo(this.current - 1));
      this.nextButton?.addEventListener('click', () => {
        if (this.validateStep(this.current)) this.goTo(this.current + 1);
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target.tagName !== 'TEXTAREA' && this.current !== this.total) {
          event.preventDefault();
          if (this.validateStep(this.current)) this.goTo(this.current + 1);
        }
      });
      this.addEventListener('change', (event) => {
        if (event.target.type !== 'radio') return;
        const step = event.target.closest('[data-wizard-step]');
        if (!step || !step.hasAttribute('data-wizard-auto-advance')) return;
        clearTimeout(this.autoAdvanceTimer);
        this.autoAdvanceTimer = setTimeout(() => {
          if (this.validateStep(this.current)) this.goTo(this.current + 1);
        }, 400);
      });

      this.render();
    }

    validateStep(stepNumber) {
      const step = this.steps[stepNumber - 1];
      const seenRadioGroups = new Set();
      const fields = Array.from(step.querySelectorAll('input[required], textarea[required]'));

      for (const field of fields) {
        if (field.type === 'radio') {
          if (seenRadioGroups.has(field.name)) continue;
          seenRadioGroups.add(field.name);
          const checked = step.querySelector(`input[name="${field.name}"]:checked`);
          if (!checked) {
            field.reportValidity();
            return false;
          }
        } else if (!field.checkValidity()) {
          field.reportValidity();
          return false;
        }
      }
      return true;
    }

    goTo(stepNumber) {
      if (stepNumber < 1 || stepNumber > this.total) return;
      clearTimeout(this.autoAdvanceTimer);
      this.current = stepNumber;
      this.render();
    }

    render() {
      this.steps.forEach((step, index) => {
        step.classList.toggle('is-active', index + 1 === this.current);
      });
      const currentStep = this.steps[this.current - 1];
      const isAutoAdvance = currentStep.hasAttribute('data-wizard-auto-advance');
      const isLastStep = this.current === this.total;
      if (this.progressBar) this.progressBar.style.width = `${(this.current / this.total) * 100}%`;
      if (this.stepLabel) this.stepLabel.textContent = `Step ${this.current} of ${this.total}`;
      if (this.backButton) this.backButton.hidden = this.current === 1;
      if (this.nextButton) this.nextButton.hidden = isLastStep || isAutoAdvance;
      if (this.submitButton) this.submitButton.hidden = !isLastStep;
    }
  }

  customElements.define('mural-quote-wizard', MuralQuoteWizard);
  } catch(e) { console.error(e); }
})();

})();
